module.exports = __webpack_public_path__ + "img/circle.6fb9c4ce.svg";